export const trackGaClick = ({ id, gaAction, gaType, extra = {} }) => {
	if (typeof window === "undefined") return;

	window.dataLayer = window.dataLayer || [];

	window.dataLayer.push({
		event: "ui_action",
		id,
		ga_action: gaAction,
		ga_type: gaType || null,
		...extra,
	});
};
